
<template>
  <a>
    <span class="modal-body-text">You are about to delete an event. If you choose to continue, you cannot recover your event.</span><br /><br />
    <span class="modal-body-text">Are you sure you want to continue?</span> <br />
  </a>
</template>

<script>
export default {
  name: 'delete-body-modal'
}
</script>

<style lang="less">

</style>




// WEBPACK FOOTER //
// DeleteEvent.vue?35c94a62